import Vue from 'vue';
import Router from 'vue-router';

import NotFound from './components/NotFound.vue';
import Forbidden from './components/Forbidden.vue';
import ConfirmMail from './components/ConfirmMail.vue';
import ConfirmAccount from './components/ConfirmAccount.vue';
import Index from './components/Index.vue';
import Login from './components/Login.vue';
import RestoreRequest from 'components/RestoreRequest';
import RestorePassword from 'components/RestorePassword';
import Account from './components/Account.vue';
import ChangePassword from './components/ChangePassword.vue';
import ChangeMail from './components/ChangeMail.vue';
import PermissionsRequest from './components/PermissionsRequest';
import AdminPanel from './components/AdminPanel';
import Unsubscribe from './components/Unsubscribe.vue';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/restore',
            name: 'RestorePassword',
            component: RestorePassword
        },
        {
            path: '/unsubscribe',
            name: 'Unsubscribe',
            component: Unsubscribe
        },
        {
            path: '/restore/request',
            name: 'RestoreRequest',
            component: RestoreRequest
        },
        {
            path: '/account',
            name: 'Account',
            component: Account
        },
        {
            path: '/change-password',
            name: 'ChangePassword',
            component: ChangePassword
        },
        {
            path: '/change-mail',
            name: 'ChangeMail',
            component: ChangeMail
        },
        {
            path: '/admin',
            name: 'AdminPanel',
            component: AdminPanel
        },
        {
            path: '/teacher/:type',
            name: 'PermissionsRequest',
            component: PermissionsRequest
        },
        {
            path: '/confirm/mail',
            name: 'ConfirmMail',
            component: ConfirmMail
        },
        {
            path: '/confirm/account',
            name: 'ConfirmAccount',
            component: ConfirmAccount
        },
        {
            path: '/forbidden',
            name: 'Forbidden',
            component: Forbidden
        },
        {
            path: '/not-found',
            name: 'NotFound',
            component: NotFound
        },
        {
            path: '/privacy-policy',
            name: 'PrivacyPolicy',
            component: () => import('./components/PrivacyPolicy.vue')
        },
        {
            path: '/user-agreement',
            name: 'UserAgreement',
            component: () => import('./components/UserAgreement.vue')
        },
        {
            path: '/personal-data-agreement',
            name: 'PersonalDataAgreement',
            component: () => import('./components/PersonalDataAgreement.vue')
        },
        {
            path: '*',
            component: NotFound
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (from.query.redirectWebsites && !to.query.redirectWebsites && to.name !== 'Forbidden' && to.name !== 'NotFound' && to.name !== 'Index') {
        to.query.redirectWebsites = from.query.redirectWebsites;
        next(to);
    }
    else {
        next();
    }
});
